export default __webpack_public_path__ + "static/media/logo-silueta.21a51eb4.svg";